import { ref } from 'vue';

const visible = ref(false);
const busy = ref(false);
let retryAction = null;
let retryInFlight = null;
let reloadUsed = false;

function showFailure() {
  visible.value = true;
}

function retry() {
  if (retryInFlight) return retryInFlight;
  if (!retryAction) return Promise.resolve();
  busy.value = true;
  retryInFlight = Promise.resolve()
    .then(retryAction)
    .then(
      () => {
        visible.value = false;
      },
      () => {
        visible.value = true;
      },
    )
    .finally(() => {
      busy.value = false;
      retryInFlight = null;
    });
  return retryInFlight;
}

function reload() {
  if (reloadUsed) return;
  reloadUsed = true;
  window.location.reload();
}

export function useAuthRecoveryState() {
  return {
    visible,
    busy,
    setRetry: (action) => {
      retryAction = action;
    },
    showFailure,
    retry,
    reload,
  };
}
